console.log('node-load not implemented');
throw new Error('react_client_wallet is not meant for node js!!!');